import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@goto/insights',
  esModule: true,
  get url() {
    const version = getFeatureFlag('insights-version', 'latest')
    return new URL(`/experiences/insights/${version}/insights-extension.js`, location.origin)
  },
  prerequisites: {[PrerequisiteRuleTypes.SHELL_FEATURE_FLAGS]: "insights.enable",},
  dependencies: ['@goto/shell-extensions-widgets'],
}

export default extensionConfig
